import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import { getNodeById } from "../../../nodeSelector";
import * as nodeUtils from "../../../utils/nodeUtils";
import * as pathUtils from "../../../utils/pathUtils";
import * as systemUtils from "../../../utils/systemUtils";
import { ACTION_PREFIX_CHOICE } from "./abstract/choiceAbstract";

const _action = `${ACTION_PREFIX_CHOICE}_move_flat`;
const _header = `Move choice`;

export const moveChoiceFlat = (root, id, idDestinationParent, indexDestination) => {
  const _payload = moveChoiceFlatLogic(root, id, idDestinationParent, indexDestination);

  logger.logAction(_action, _payload, ACTION_PREFIX_CHOICE);

  return { root, info: _payload };
};

//--------------------------------------------------------------------------------

export const moveChoiceFlatLogic = (root, id, idDestinationParent, indexDestination) => {
  const _idParent = pathUtils.getIdParent(id);
  const { data: _node, index: _index } = getNodeById(root, id);
  const { data: _nodeParent } = getNodeById(root, _idParent);
  const { data: _nodeDestinationParent } = getNodeById(root, idDestinationParent);
  const { data: _nodeCopy } = nodeUtils.copy(_node, { idParent: idDestinationParent });

  if (!_node) {
    throw new Error("Choice to move not found");
  } else if (!_nodeParent) {
    throw new Error("Parent node not found");
  } else if (!_nodeDestinationParent) {
    throw new Error("Destination parent node not found");
  }

  const _indexParsed =
    indexDestination ??
    (_idParent === idDestinationParent
      ? nodeUtils.getChoices(_nodeDestinationParent).length - 1
      : nodeUtils.getChoices(_nodeDestinationParent).length);

  const _nodeBackup = systemUtils.createDeepCopy(_node);

  if (_nodeParent !== _nodeDestinationParent) {
    const _destChoices = nodeUtils
      .getChoices(_nodeDestinationParent)
      .map((e) => nodeUtils.getName(e));

    if (_destChoices.includes(nodeUtils.getName(_nodeCopy))) {
      let _updateName = nodeUtils.getName(_nodeCopy);
      let _index = 1;

      while (_destChoices.includes(`${_updateName} - ${_index}`)) {
        _index++;
      }

      nodeUtils.setName(_nodeCopy, `${_updateName} - ${_index}`, true);
    }
  }

  detachNode(_nodeParent, id);
  attachNode(_nodeDestinationParent, _nodeCopy, _indexParsed);

  return generatePayload(_nodeBackup, _index, _nodeParent, _nodeDestinationParent, _indexParsed);
};

const detachNode = (node, id) => {
  const fun = (e) => e.filter((f) => nodeUtils.getID(f) !== id);
  nodeUtils.modifyChoices(node, fun, true);
};

const attachNode = (nodeReference, nodeDragged, index) => {
  const funAdd = (e) => e.push(nodeDragged);
  const funPosition = (e) => e.splice(index, 0, nodeDragged);
  const fun = (e) => (!index && index !== 0 ? funAdd(e) : funPosition(e));
  nodeUtils.modifyChoices(nodeReference, fun, false);
};

//--------------------------------------------------------------------------------

const generatePayload = (node, index, nodeParent, nodeDestinationParent, indexDestination) => {
  const _payload = {
    group: ActionGroupTypes.UPDATE,
    status: ActionStatusTypes.SUCCESS,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: generatePayloadDescription(node, nodeParent, nodeDestinationParent),
    node: node,
    uuid: nodeUtils.getUUID(node),
    uuidParent: nodeUtils.getUUID(nodeParent),
    index: index,
    uuidDestinationParent: nodeUtils.getUUID(nodeDestinationParent),
    indexDestination: indexDestination,
  };

  return _payload;
};

const generatePayloadDescription = (node, nodeParent, nodeDestinationParent) => {
  return `Move choice '${nodeUtils.getName(node)}' from '${nodeUtils.getName(
    nodeParent
  )}' to '${nodeUtils.getName(nodeDestinationParent)}'.`;
};
